export const ENABLE_INACTIVITY_TIMER = 'ENABLE_INACTIVITY_TIMER';
export const DISABLE_INACTIVITY_TIMER = 'DISABLE_INACTIVITY_TIMER';

